import React from 'react';
import { Link } from 'react-router-dom';
import { dashboardUrl } from '../../config/app';
import './CTAButton.css';

export const CTA_TARGETS = {
  dashboard: '/login',
  templates: '/templates',
  ai: '/ai-template-designer',
  audience: '/audience-tools',
  automation: '/automation-builder',
  builder: '/email-builder',
  segmentation: '/segmentation-tools',
};

export default function CTAButton({ children = 'Get started', className = '', kind = 'dashboard', to }) {
  const target = to || CTA_TARGETS[kind] || CTA_TARGETS.dashboard;
  const classes = `site-cta-btn ${className}`.trim();

  if ((to && String(target).startsWith('/')) || kind !== 'dashboard') {
    return <Link to={target} className={classes}>{children}</Link>;
  }

  if (/^https?:\/\//.test(String(target))) {
    return <a href={target} className={classes}>{children}</a>;
  }

  return <a href={dashboardUrl(target)} className={classes}>{children}</a>;
}
